import differenceWith from "lodash/differenceWith";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import { FilterWithDefaults, Value } from "PFTypes";

// TODO: [SP-6421] replace remaining usages with canFilterBeRestored from helpers/filters/misc.ts
export const letFilterRestore = (filter: FilterWithDefaults) => {
  const defaultValue = filter.defaultValue ?? filter.default_value;
  return !isNil(defaultValue) && !isEmpty(defaultValue) && !areFilterValuesEqual(filter.value, defaultValue);
};

export const areFilterValuesEqual = (filterValue1: Value, filterValue2: Value) => {
  if (isArray(filterValue1) && isArray(filterValue2)) {
    // has same values regardless of order
    return (
      isEmpty(differenceWith(filterValue1, filterValue2, isEqual)) &&
      isEmpty(differenceWith(filterValue2, filterValue1, isEqual))
    );
  }

  return isEqual(filterValue1, filterValue2);
};
